import { TfoCookie } from '@tfo/common/src/utils/Cookie'
import Axios, { AxiosPromise, AxiosRequestConfig, AxiosResponse } from 'axios'
import { get, remove } from 'js-cookie'

const $http = {
    _cookieKey: 'tfoCustomerPortal',

    get: async function <T>(endpoint: string, responseType?: string, contentType?: string, accept?: string): Promise<T> {
        return await this._promise<T>(Axios.get(this._getUrl(endpoint), this._getConfig(contentType, accept, responseType)))
    },

    post: async function <T>(endpoint: string, data?: any, responseType?: string, contentType?: string, accept?: string): Promise<T> {
        return await this._promise<T>(Axios.post(this._getUrl(endpoint), data, this._getConfig(contentType, accept, responseType)))
    },

    put: async function <T>(endpoint: string, data: any, responseType?: string, contentType?: string, accept?: string): Promise<T> {
        return await this._promise<T>(Axios.put(this._getUrl(endpoint), data, this._getConfig(contentType, accept, responseType)))
    },

    patch: async function <T>(endpoint: string, data: any, responseType?: string, contentType?: string, accept?: string): Promise<T> {
        return await this._promise<T>(Axios.patch(this._getUrl(endpoint), data, this._getConfig(contentType, accept, responseType)))
    },

    delete: async function <T>(endpoint: string, data?: any, responseType?: string, contentType?: string, accept?: string): Promise<T> {
        return await this._promise<T>(Axios.delete(this._getUrl(endpoint), { ...this._getConfig(contentType, accept, responseType), data }))
    },

    _promise: async function <T>(promise: AxiosPromise): Promise<T> {
        return (await promise
            .then(response => {
                return response
            }) as AxiosResponse).data as T
    },

    _getUrl: function (endpoint: string): string {
        return `https://${(window as any).tfoEnv}${endpoint}`
    },

    _getConfig: function (contentType?: string, accept?: string, responseType?: string): AxiosRequestConfig {
        const cookie = this._getCookie();
        const token = (window as any)?.tfoToken ? (window as any)?.tfoToken : cookie?.token;
        return {
            headers: {
                Authorization: `bearer ${token}`,
                ContentType: contentType ?? 'application/json',
                Accept: accept ?? 'application/json'
            },
            responseType: responseType ?? 'json'
        }
    },

    _getCookie: function (): Partial<TfoCookie> {
        const rawCookieText = sessionStorage.getItem(this._cookieKey) || get(this._cookieKey)
        try {
            return rawCookieText ? JSON.parse(rawCookieText) : {}
        } catch (error) {
            console.error(error)
            remove(this._cookieKey)
            return {}
        }
    }
}

export default $http